.card {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.row {
  display: inline-flex;
  gap: var(--tuna-spacing-1);
  align-items: baseline;
  flex-wrap: wrap;
}

.label {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.chordName {
  margin: 0;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
  font-family: ui-monospace, monospace;
}
